// dataContext.js
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const DataContext = createContext({
  sedacky: [],
  nabytok: [],
  latky: [],
  loading: true,
  error: null,
});

export const DataProvider = ({ children }) => {
  const [nabytok, setNabytok] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ac = new AbortController();

    (async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch('https://skladcms.vercel.app/api/nabytok', {
          signal: ac.signal,
          cache: 'no-store', // nech to neťahá zo starej cache
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        if (!ac.signal.aborted) setNabytok(Array.isArray(data) ? data : []);
      } catch (e) {
        if (!ac.signal.aborted) setError('Failed to fetch nabytok.');
        console.error('Error fetching nabytok:', e);
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    })();

    return () => ac.abort();
  }, []);

  const value = useMemo(
    () => ({
      sedacky: [],      // zámerne prázdne kvôli kompatibilite
      nabytok,
      latky: [],        // zámerne prázdne kvôli kompatibilite
      loading,
      error,
    }),
    [nabytok, loading, error]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);
